import React, { useContext, useLayoutEffect } from 'react';
import Modal from 'components/Modal';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import DynamicPageContext from 'context/DynamicPage';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { returnTitle, returnFormBySlug } from './function';
import { saveModuleOnBack, editModuleOnBack } from './reqs';
import { getcomponentsBySlug } from 'components/MobileDynamicPage/reqs';

export default function FormDynamicPageSelected() {
	const { t }: UseTranslationProps = useTranslation();
	const {
		isFormOpen,
		setIsFormOpen,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit,
		moduleInSavingMode,
		setModuleInSavingMode,
		dynamicPageSelected,
		itensOnPhone,
		setItensOnPhone,
		setCanSaveModuleOnBack,
		canSaveModuleOnBack,
		messageErrorForm,
		setItensOnPhoneBackup
	} = useContext(DynamicPageContext);

	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	function cancel() {
		if (moduleInSavingMode !== null) {
			setItensOnPhone((prevItems) =>
				prevItems.filter((module) => module.id !== moduleInSavingMode.id)
			);
		}

		// Pequeno delay para evitar race condition no estado
		setTimeout(() => {
			setIsFormOpen(false);
			setModuleOnPhoneToEdit(null);
			setModuleInSavingMode(null);
			setCanSaveModuleOnBack(false);
		}, 100);
	}

	async function handleSave() {
		if (
			moduleInSavingMode !== null &&
			dynamicPageSelected !== null &&
			canSaveModuleOnBack
		) {
			setIsOpenLoad(true);
			setMessage('Salvando módulo');

			const { isSuccess } = await saveModuleOnBack(
				moduleInSavingMode,
				dynamicPageSelected,
				itensOnPhone,
				handleNotify
			);

			if (isSuccess) {
				const { data, isSuccess } = await getcomponentsBySlug(
					dynamicPageSelected.slug,
					handleNotify
				);

				if (isSuccess && data) {
					setItensOnPhone(data);
					setItensOnPhoneBackup(data);
				}

				setIsFormOpen(false);
				setCanSaveModuleOnBack(false);
			}

			handleNotify('Módulo salvo com sucesso', 'success');
			setIsOpenLoad(false);
		} else {
			handleNotify(
				messageErrorForm === ''
					? 'Existe algum erro no formulário, verifique os campos'
					: messageErrorForm,
				'error'
			);
		}
	}

	async function handleEdit() {
		if (
			moduleOnPhoneToEdit !== null &&
			canSaveModuleOnBack &&
			dynamicPageSelected !== null
		) {
			setIsOpenLoad(true);
			setMessage('Editando módulo');

			const { isSuccess } = await editModuleOnBack(
				moduleOnPhoneToEdit,
				handleNotify
			);

			if (isSuccess) {
				const { data, isSuccess } = await getcomponentsBySlug(
					dynamicPageSelected.slug,
					handleNotify
				);

				if (isSuccess && data) {
					setItensOnPhone(data);
					setItensOnPhoneBackup(data);
				}

				setIsFormOpen(false);
				setCanSaveModuleOnBack(false);
			}

			handleNotify('Módulo editado com sucesso', 'success');
			setIsOpenLoad(false);
		} else {
			handleNotify(
				messageErrorForm === ''
					? 'Existe algum erro no formulário, verifique os campos'
					: messageErrorForm,
				'error'
			);
		}
	}

	//reseta infos quando o formulario é fechado
	useLayoutEffect(() => {
		return () => {
			setModuleOnPhoneToEdit(null);
			setModuleInSavingMode(null);
		};
	}, []);

	return (
		<Modal
			isOpenProps={isFormOpen}
			setIsOpenModal={() => {
				cancel();
			}}
			title={t(returnTitle(moduleOnPhoneToEdit?.slug || 'notFound'))}
			buttonClose={false}
		>
			<S.container>
				<S.boxForm>
					{moduleOnPhoneToEdit && returnFormBySlug(moduleOnPhoneToEdit.slug)}
				</S.boxForm>

				<S.containerBtns>
					<S.cancel onClick={cancel}>Cancelar</S.cancel>
					<S.save
						onClick={
							moduleOnPhoneToEdit !== null && moduleInSavingMode !== null
								? handleSave
								: handleEdit
						}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
